<!--Navbar-->
<pmd-navbar class="navbar navbar-expand-xl align-items-center" id="navbar">

	<!-- Navbar Toggler -->
	<a href="javascript:void(0);" pmd-btn pmdRipple pmd-btn-fab pmd-btn-flat color="" size="sm"
		class="pmd-sidebar-toggle my-0 d-xl-none">
		<i class="material-icons-round md-dark">menu</i>
	</a>

	<!-- Screen Title -->
	<div class="screen-title">
		<h1 class="h2">{{titleObj.title}} </h1>
		<p class="lead mb-0">{{titleObj.subtitle}}</p>
	</div><!-- END - Screen Title -->

	<!-- Navbar brand -->
	<pmd-navbar-brand>
		<a class="navbar-brand d-xl-none" href="javascript:void(0)">
			<img src="assets/images/egarage-logo-white.svg"
				height="40"></a>
	</pmd-navbar-brand>

	<!-- Navbar Right Information -->
	<pmd-navbar-right-icon class="d-flex align-items-center">

		<!-- Global Search -->
		<!-- <a class="d-block d-sm-none" pmdRipple pmd-btn-fab pmd-btn-flat color="light" size="sm"
			href="javascript:void(0);">
			<i class="material-icons-round pmd-icon-sm">search</i>
		</a> -->
		<form class="form-inline me-3 app-global-search d-none d-lg-flex">
			<input class="default-input" type="text" placeholder="Search..." aria-label="Search">
		</form>

		<!-- Notifications -->
		<div class="dropdown me-3 pmd-dropdown ms-auto" pmdDropdown >
			<a class="dropdown-toggle no-caret m-0" pmdDropdownToggle pmdRipple pmd-btn-fab color="default" size="sm"
				href="javascript:void(0);">
				<i class="material-icons-round pmd-icon-sm">notifications</i>
			</a>
			<div class="list-group pmd-list dropdown-menu notification-dropdown dropdown-menu-right" *pmdDropdownMenu
				aria-labelledby="navbarDropdown">
				<a href="javascript:void(0)" class="list-group-item d-flex flex-row">
					<i class="material-icons pmd-icon-circle bg-grey pmd-icon-sm me-3">settings</i>
					<div class="flex-grow-1">
						<p class="pmd-list-title">A new job card is created BMW C2 for AC Servicing </p>
						<p class="pmd-list-subtitle">2 Hrs Ago</p>
					</div>
				</a>
				<a href="javascript:void(0)" class="list-group-item d-flex flex-row">
					<i class="material-icons pmd-icon-circle bg-grey pmd-icon-sm me-3">person_add</i>
					<div class="flex-grow-1">
						<p class="pmd-list-title">New mechanic is registered and pending for approval</p>
						<p class="pmd-list-subtitle">4 Hrs Ago</p>
					</div>
				</a>
				<a href="javascript:void(0)" class="list-group-item d-flex flex-row">
					<i class="material-icons pmd-icon-circle bg-grey pmd-icon-sm me-3">receipt</i>
					<div class="flex-grow-1">
						<p class="pmd-list-title">Thomas has completed the Job Card</p>
						<p class="pmd-list-subtitle">10 Hrs Ago</p>
					</div>
				</a>
				<a href="javascript:void(0)" class="list-group-item d-flex flex-row">
					<i class="material-icons pmd-icon-circle bg-grey pmd-icon-sm me-3">directions_car</i>
					<div class="flex-grow-1">
						<p class="pmd-list-title">The Mercedec Q6 (MH-08-RT-8695) is ready for delivery after service
						</p>
						<p class="pmd-list-subtitle">Yesterday</p>
					</div>
				</a>
				<a href="javascript:void(0)" class="list-group-item d-flex flex-row">
					<i class="material-icons pmd-icon-circle bg-grey pmd-icon-sm me-3">local_shipping</i>
					<div class="flex-grow-1">
						<p class="pmd-list-title">ORD - 128 has been delivered to the Globex Corporation</p>
						<p class="pmd-list-subtitle">24 Mar, 2020</p>
					</div>
				</a>
			</div>
		</div>

		<!-- Logged in User Information -->
		<div class="dropdown pmd-dropdown pmd-user-info ms-auto" pmdDropdown>
			<a href="javascript:void(0);" pmdDropdownToggle
				class="btn-user p-0 dropdown-toggle d-flex align-items-center">

				<span class="pmd-avatar-list-img" href="javascript:void(0);">
					<img data-holder-rendered="true" src="assets/images/user-avatar.png" class="img-fluid"
						data-src="holder.js/40x40" alt="40x40">
				</span>
				<div class="flex-grow-1 d-none d-sm-block">
					<h6 class="mb-0">Robert S.</h6>
					<small>Admin</small>
				</div>
			</a>
			<ul class="dropdown-menu dropdown-menu-right" *pmdDropdownMenu aria-labelledby="navbarDropdown">
				<a class="dropdown-item" href="javascript:void(0);">Edit Profile</a>
				<a class="dropdown-item" pmdRipple href="javascript:void(0);">Logout</a>
			</ul>
		</div>
	</pmd-navbar-right-icon>

</pmd-navbar>
<!--/.Navbar-->